import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { OriginDestinationSummaryRequest, OriginDestinationSummaryResponse, OriginDestinationSummaryStatus } from './origin-destination-summary-report.models';

@Injectable({ providedIn: 'root' })
export class OriginDestinationSummaryReportApiService {
  async load(payload: OriginDestinationSummaryRequest): Promise<OriginDestinationSummaryResponse> {
    const response = await axios.post('Radyab_MobilesRespectOriginDestination', payload);
    const data: unknown = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') {
      const status = data as OriginDestinationSummaryStatus;
      if (status.ISSessionExpired || status.ISessionExpired || status.iResult === 0) return status;
    }
    throw new Error('پاسخ گزارش نامعتبر است');
  }
}
